import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FilesService } from '../../../core/services/files.service';
import { FleetService } from '../../../core/services/fleet.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { RepairsService } from '../../../core/services/repairs.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';

const ADD_EDIT_REPAIRS_PAYMENT_UPLOAD = 'ADD_EDIT_REPAIRS_PAYMENT_UPLOAD';

const ADD_EDIT_REPAIRS_REPAIR_UPLOAD = 'ADD_EDIT_REPAIRS_REPAIR_UPLOAD';

@Component({
  selector: 'app-add-edit-repairs',
  templateUrl: './add-edit-repairs.component.html',
  styleUrls: ['./add-edit-repairs.component.scss'],
})
export class AddEditRepairsComponent implements OnInit, IDeactivateComponent {
  repairsForm: FormGroup | any;
  repairId: any;
  repairData: any;
  status = 'create';
  nzShowArrow = true;
  formErrors: any;
  repairFiles: any[] = [];
  paymentFiles: any[] = [];
  listOfOption = [
    '1 Tyre',
    '2 Tyres',
    '3 Tyres',
    'All Tyres',
    'Breaks Pads',
    'Battery',
    'Other',
  ];
  listOfSelectedValue = [];
  breadcrumbs: any[] = [];
  fleetId: any;
  fleetData = {
    vehicleDetails: {
      vehicleModel: '',
      registrationNumber: '',
    },
    generalInformation: {
      vehicleType: '',
    },
  };
  prevPage = '';
  currentDate = new Date();
  loading = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }
  formatterCurrencyMonthRent = (value: number): string => `Rs. ${value}`;
  parserCurrencyMonthRent = (value: string): string =>
    value.replace('Rs. ', '');
  paymentUploading = false;
  repairUploading = false;
  submit = false;

  constructor(
    private fb: FormBuilder,
    private fleetService: FleetService,
    private route: ActivatedRoute,
    private filesService: FilesService,
    private repairService: RepairsService,
    private router: Router,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.uploadLoading();
    this.initInspectionForm();
    this.repairFiles = [];
    this.paymentFiles = [];
    this.route.queryParams.subscribe((params) => {
      this.prevPage = params['prev'];
    });
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.repairId = this.route.snapshot.paramMap.get('id');
    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      console.log(res);
      this.fleetData = res;
      if (this.fleetData.generalInformation.vehicleType === 'SR') {
        this.repairsForm.get('breakdownDetails.repairDoneBy').patchValue('SR');
        this.repairsForm.get('breakdownDetails.repairDoneBy').disable();
      }
      if (this.repairId) {
        this.breadcrumbs = [
          {
            title: 'Fleets',
            icon: 'car',
            route: '/admin/fleets',
          },
          {
            title: this.fleetData.vehicleDetails?.registrationNumber,
          },
          {
            title: ' Repair Records ',
            route: [
              `/admin/fleets/${this.fleetId}`,
              { pageName: 'fleetRepairs' },
            ],
          },
          {
            title: ' Edit Repair Record',
          },
        ];
      } else {
        this.breadcrumbs = [
          {
            title: 'Fleets',
            icon: 'car',
            route: '/admin/fleets',
          },
          {
            title: this.fleetData.vehicleDetails?.registrationNumber,
            route: `/admin/fleet/${this.fleetId}`,
          },
          {
            title: ' Repair Records ',
            route: [
              `/admin/fleets/${this.fleetId}`,
              { pageName: 'fleetRepairs' },
            ],
          },
          {
            title: ' Add Repair Record ',
          },
        ];
      }
    });

    if (this.repairId) {
      this.loading = true;
      this.repairService.getRepairById(this.repairId).then((res) => {
        this.status = 'edit';
        this.repairData = res;
        if (res.paymentAttachments) {
          this.paymentFiles = res.paymentAttachments;
        }
        if (res.repairsAttachment) {
          this.repairFiles = res.repairsAttachment;
        }
        this.repairsForm.patchValue(this.repairData);
        this.loading = false;
      });
    }
  }

  initInspectionForm(): void {
    this.repairsForm = this.fb.group({
      breakdownDetails: this.fb.group({
        breakdownDate: [null, Validators.required],
        repairDoneBy: [null, Validators.required],
        issueType: [[], Validators.required],
        otherIssue: [null],
        notesBreakdown: [null],
      }),
      repairInformation: this.fb.group({
        partsReplacedByCustomer: [['']],
        otherParts: [null],
        repairStartDate: [null],
        repairEndDate: [null],
        actualRepairStartDate: [null],
        backToFleetDate: [null],
        notesInformation: [null],
      }),
      paymentDetails: this.fb.group({
        paymentDoneBy: [null, Validators.required],
        totalCost: [0, Validators.required],
        repaymentType: [null],
        installments: [null],
        installmentPeriod: [null],
        notesPayments: [null],
      }),
    });

    this.repairsForm
      .get('breakdownDetails.repairDoneBy')
      .valueChanges.subscribe((value: string) => {
        const repairInformation = this.repairsForm.get('repairInformation');
        if (value === 'Rental Customer') {
          repairInformation
            .get('partsReplacedByCustomer')
            .setValidators(Validators.required);
          repairInformation
            .get('repairStartDate')
            .setValidators(Validators.required);
          repairInformation
            .get('repairEndDate')
            .setValidators(Validators.required);
        } else {
          repairInformation.get('partsReplacedByCustomer').clearValidators();
          repairInformation.get('repairStartDate').clearValidators();
          repairInformation.get('repairEndDate').clearValidators();
        }
        repairInformation
          .get('partsReplacedByCustomer')
          .updateValueAndValidity();
        repairInformation.get('repairStartDate').updateValueAndValidity();
        repairInformation.get('repairEndDate').updateValueAndValidity();
      });

    this.repairsForm
      .get('paymentDetails.paymentDoneBy')
      .valueChanges.subscribe((value: string) => {
        const paymentDetails = this.repairsForm.get('paymentDetails');
        if (value === 'Vehicle Owner') {
          paymentDetails
            .get('repaymentType')
            .setValidators(Validators.required);
          paymentDetails.get('installments').setValidators(Validators.required);
        } else {
          paymentDetails.get('repaymentType').clearValidators();
          paymentDetails.get('installments').clearValidators();
        }
        paymentDetails.get('repaymentType').updateValueAndValidity();
        paymentDetails.get('installments').updateValueAndValidity();
      });
  }

  initFormErrors() {
    this.formErrors = {
      breakdownDetails: {
        breakdownDate: {},
        repairDoneBy: {},
        issueType: {},
        otherIssue: {},
        notesBreakdown: {},
      },
      repairInformation: {
        partsReplacedByCustomer: {},
        otherParts: {},
        repairStartDate: {},
        repairEndDate: {},
        actualRepairStartDate: {},
        backToFleetDate: {},
        notesInformation: {},
      },
      paymentDetails: {
        paymentDoneBy: {},
        totalCost: {},
        repaymentType: {},
        installments: {},
        installmentPeriod: {},
        notesPayments: {},
      },
    };
  }

  uploadLoading(): void {
    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case ADD_EDIT_REPAIRS_REPAIR_UPLOAD:
          this.repairUploading = res.loading;
          break;
        case ADD_EDIT_REPAIRS_PAYMENT_UPLOAD:
          this.paymentUploading = res.loading;
          break;
      }
    });
  }

  paymentUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_REPAIRS_PAYMENT_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.paymentFiles.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_REPAIRS_PAYMENT_UPLOAD,
          loading: false,
        });
      });

  repairUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_REPAIRS_REPAIR_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.repairFiles.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_REPAIRS_REPAIR_UPLOAD,
          loading: false,
        });
      });

  onSubmit(): void {
    this.repairsForm.get('breakdownDetails.repairDoneBy').enable();
    this.repairService
      .createRepair({
        fleet: this.fleetId,
        ...this.repairsForm.value,
        repairsAttachment: this.repairFiles,
        paymentAttachments: this.paymentFiles,
      })
      .then((res) => {
        console.log(res);
        this.submit = true;
        this.router.navigate([
          `/admin/fleets/${this.fleetId}`,
          { pageName: 'fleetRepairs' },
        ]);
      });
  }

  onUpdate(): void {
    this.repairService
      .updateRepair({
        _id: this.repairId,
        ...this.repairsForm.value,
        paymentAttachments: this.paymentFiles,
        repairAttachment: this.repairFiles,
      })
      .then(() => {
        if (this.prevPage) {
          this.submit = true;
          this.router.navigate([
            `admin/fleets/${this.fleetId}/repair/${this.repairId}`,
          ]);
        } else {
          this.submit = true;
          this.router.navigate([
            `/admin/fleets/${this.fleetId}`,
            { pageName: 'fleetRepairs' },
          ]);
        }
      });
  }

  confirmRemoveAttachment(attachmentId: any): void {
    this.message.create('success', `Attachment has been deleted!`);
    this.paymentFiles.splice(attachmentId, 1);
  }

  confirmRemoveAttachmentRepair(attachmentId: any): void {
    this.message.create('success', `Attachment has been deleted!`);
    this.repairFiles.splice(attachmentId, 1);
  }

  cancel(): void {}

  confirm(): void {
    if (this.prevPage) {
      this.router.navigate([
        `admin/fleets/${this.fleetId}/repair/${this.repairId}`,
      ]);
    } else {
      this.router.navigate([
        `/admin/fleets/${this.fleetId}`,
        { pageName: 'fleetRepairs' },
      ]);
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.submit) {
      return true;
    } else if (this.repairsForm.dirty || this.repairsForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }
}
